import { ExcursionsTableWidgetData } from './template-builder-excersions-table-widget.model';
import { TableWidgetData } from './template-builder-table-widget.model';

export enum EmailDynamicWidgetDataKey {
  title = 'title',
  activitiesDay = 'activitiesDay',
  imagePath = 'imagePath',
  registrationDetailsTable = 'registrationDetailsTable',
  transactionTable = 'transactionTable',
  excursionsTable = 'excursionsTable',
  formResultsTable = 'formResultsTable',
}

export class EmailDynamicWidgetData {
  [EmailDynamicWidgetDataKey.formResultsTable]?: TableWidgetData = new TableWidgetData();
  [EmailDynamicWidgetDataKey.title]?: string = '';
  [EmailDynamicWidgetDataKey.activitiesDay]?: string = '';
  [EmailDynamicWidgetDataKey.imagePath]?: string = '';
  [EmailDynamicWidgetDataKey.registrationDetailsTable]?: TableWidgetData = new TableWidgetData();
  [EmailDynamicWidgetDataKey.transactionTable]?: TableWidgetData = new TableWidgetData();
  [EmailDynamicWidgetDataKey.excursionsTable]?: ExcursionsTableWidgetData = new ExcursionsTableWidgetData();
}
